import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Auth } from 'aws-amplify';
@Injectable({
    providedIn: 'root'
})
export class DataService {
    private headers: HttpHeaders = new HttpHeaders({ "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" });
    private header: any;
    constructor(
        private http: HttpClient,
    ) {
        this.getCurrentSession();
    }
    // get data with params
    private async getCurrentSession() {
        const currentSession = await Auth.currentSession();
        const idToken = currentSession && currentSession.getIdToken()

        this.header = {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': idToken ? `${idToken.getJwtToken()}` : ''
        };

        //  return this.header

    }
    public getData(uri: string) {
        return this.http.get(uri, { headers: this.header }).pipe(catchError(this.handleError));
    }
    // post data with params and body

    public postData = (uri: string, bodyString?: any, headers?: any) => {
        if (headers && headers.Authorization) {
            this.headers = this.headers.set('Authorization', headers.Authorization);
        }

        return this.http.post(uri, bodyString, { headers: this.header }).pipe(catchError(this.handleError));
    };

    private handleError(error: Response | any) {
        return throwError(error);
    }

    decodeURIComponentSpecial(encodedString) {
        // special handling for + 
        // The compression logic sometimes generates + symbol and this comes in querystring after encodeURI from admin
        // The reverse decodeURI treats + as SPACE and give space which breaks
        // So add code to replace SPACE with +
        return (decodeURIComponent(encodedString.replace(/\%20/g, '+')).replace(/ /g, '+'));

    }
}
